const formTypeAvailable = (AllFormStatuses, application_id) => {
  const formStatusNameMap = {
    9141: "PWD",
    "9141C": "CW1",
    "790A": "H2A",
    "9142A": "H2A",
    "9142B": "H2B",
    "9142C": "CW1",
    9035: "LCA",
    9089: "PERM",
  };
  const formStatusName = formStatusNameMap[application_id];
  const formStatus = AllFormStatuses.find(
    (fs) => fs.formType === formStatusName
  );
  return formStatus.submit;
};

export default formTypeAvailable;
